module.exports = '4.15.2';



// WEBPACK FOOTER //
// ./src/version.js